import React, { Component } from 'react';
import './ActivityMapPage.css';

import mainAPI from '../../api/MainAPI';
import ActivityMap from '../../components/activityMap/ActivityMap';
import Page from '../../components/page/Page';
import ActivityCard from './activityCard/ActivityCard';
import StaticFilterInput from '../../inputs/staticFilterInput/StaticFilterInput';
import Label from '../../components/label/Label';
import toasts from '../../utils/toasts';
import utils from '../../utils/utils';
import { AutoSizer, List } from 'react-virtualized';
import 'react-virtualized/styles.css'; // only needs to be imported once
import UpdateTitle from '../../components/updateTitle/UpdateTitle';
import {serialize} from "../../api/requests";
import PrimaryButton from "../../components/primaryButton/PrimaryButton";
import {downloadFilePost} from "../customReport/CustomReport";

let now = new Date();
now.setDate(now.getDate() + 1);
let oneDayAgo = utils.xDaysAgo(1);
let oneDayFilter = {
	created_on: {
		values: [
			{
				datetime: oneDayAgo.toISOString(),
				operator: '>'
			},
			{ datetime: now.toISOString(), operator: '<' }
		]
	}
};

export default class ActivityMapPage extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount = () => {
		this._handleFilterChange(oneDayFilter);
	};

	_handleFilterChange = async (filter) => {
		if (utils.isEmptyObject(filter)) return this.setState({ stock_move_records: [] });
		let stock_move_records = await mainAPI.stock_move_record.activityFilter(filter);
		this.setState({ stock_move_records, filter });
	};

	exportData = () => {
		const dataUrl = this.getDataUrl();
		const columns = {
			id:{label:"id"},
			record_type:{label:"Record Type"},
			created_on:{label:"Created At"},
			quantity:{label:"Quantity"},
			lat:{label:"Latitude"},
			lon:{label:"Longitude"},
			barcode_id:{label:"Barcode"},
			scanned_manually:{label:"Scanned Manually"},
			unit__name:{label:"Unit"},
			drug_box__name:{label:"Drug Box"},
			user_name:{label:"User"},
			type:{label:"Drug Type"},
			incident_number:{label:"Incident Number"},
			verified_by_name:{label:"Verifier"},
			guest_verify_name:{label:"Guest Verifier"},
			stock_move_type__display_name:{label:"Type"},
			drug_count:{label:"Drug Count"},
		}

		if (dataUrl) {
			return downloadFilePost({},"Activity", columns, '/api/v1/report/csv', dataUrl);
		}
	};

	getDataUrl = () => {
		let data = {};
		data.token = localStorage.token;
		data.user_group_id = localStorage.user_group_id;
		data.last_log_in = localStorage.last_log_in;
		data.timezone_offset = new Date().getTimezoneOffset() / 60;
		data.filter = this.state.filter;
		return (
			window.location.origin +
			'/api/v1/stock_move_record/activity/filter?' +
			serialize(data)
		);
	};


	_renderSingleActivityCard = ({ key, index, style }) => {
		let stockMoveRecord = this.getRecord(index);
		return (
			<ActivityCard
				style={style}
				key={key}
				onClick={() => {
					if (!stockMoveRecord.lat) {
						return toasts.show('Geolocation was not enabled on the device when this happened', 3000);
					}
					this.showIconOnMap(stockMoveRecord.id, stockMoveRecord.lat, stockMoveRecord.lon);
				}}
				{...stockMoveRecord}
			/>
		);
	};

	getRecord = (index) => {
		if (!this.state.stock_move_records) return {};
		return this.state.stock_move_records[index];
	};

	_renderActivity = () => {
		let list = this.state.stock_move_records || [];
		return (
			<AutoSizer>
				{({ height, width }) => (
					<List
						height={height}
						rowCount={list.length}
						rowHeight={146}
						rowRenderer={this._renderSingleActivityCard}
						width={width}
						overscanRowCount={10}
					/>
				)}
			</AutoSizer>
		);
	};

	showIconOnMap = (id, lat, lon) => {
		this.activityMap.makeIconActive(id, lat, lon);
	};

	render() {
		return (
			<Page className="g-activity-map-page">
				<UpdateTitle newTitle="Activity" originalTitle="LogRx" />
				<Label isHeader="true" larger bold black-light>
					Activity
				</Label>
				<PrimaryButton className={'export'} onClick={this.exportData}>Export</PrimaryButton>
				<StaticFilterInput
					currentFilter={[{ value: { datetime: oneDayAgo.toISOString(), operator: '>' }, column: 'created_on' }]}
					onChange={this._handleFilterChange}
					options={[
						{ column: 'created_on', displayName: 'Date', type: 'datetime' },
						{
							column: 'created_by_id',
							model: 'user',
							displayName: 'User',
							placeholder: 'All Users',
							plural: 'Users',
							filterColumns: ['first_name', 'last_name'],
							idColumn: 'id'
						},
						{
							column: 'stock_move_type_id',
							displayName: 'Type',
							placeholder: 'All Types',
							plural: 'Types',
							filterColumns: ['name'],
							options: {
								1: { name: 'Waste', id: 1 },
								2: { name: 'Administer', id: 2 },
								3: { name: 'Created', id: 3 },
								4: { name: 'Un-Administer', id: 4 },
								5: { name: 'Adjustment', id: 5 },
								199: { name: 'Reseal', id: 199 },
								99: { name: 'Inventory Check', id: 99 },
								299: { name: 'Unit Transfer', id: 299 },
								399: { name: 'Box Transfer', id: 399 }
							}
						},
						{
							column: 'unit_id',
							model: 'unit',
							displayName: 'Unit',
							placeholder: 'All Units',
							plural: 'Units',
							filterColumns: ['name'],
							idColumn: 'id'
						},
						{
							column: 'drug_box_id',
							model: 'drug_box',
							displayName: 'Drug Box',
							placeholder: 'All Drug Boxes',
							plural: 'Drug Boxes',
							filterColumns: ['name', 'barcode_id'],
							idColumn: 'id'
						},
						{
							column: 'created_on__time',
							displayName: 'Time',
							placeholder: 'All Day',
							plural: 'Times',
							filterColumns: ['name'],
							options: {
								1: { name: 'Morning', id: 1, value: { start: utils.utcHour(0), end: utils.utcHour(12) } },
								2: { name: 'Afternoon', id: 2, value: { start: utils.utcHour(12), end: utils.utcHour(17) } },
								3: { name: 'Evening', id: 3, value: { start: utils.utcHour(17), end: utils.utcHour(24) } }
							},
							noSearch: true
						}
					]}
				/>
				<div className="content-container">
					<div className="activity-container">{this._renderActivity()}</div>
					<ActivityMap
						ref={(ref) => (this.activityMap = ref)}
						onIconClick={console.log}
						coords={this.state.stock_move_records}
					/>
				</div>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/pages/activityMapPage/ActivityMapPage.jsx